import { render, staticRenderFns } from "./PurchasePayment.vue?vue&type=template&id=700193e8"
import script from "./PurchasePayment.vue?vue&type=script&lang=js"
export * from "./PurchasePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports